"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ActionTypes_1 = require("../ActionTypes");
var initialState = {
    assets: null,
    viewer: null,
    webpage: null,
    mastermodel: {
        manufacturer: "",
        model: "",
        year: ""
    }
};
function default_1(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes_1.UPDATE_STREAMING_ENVIRONMENT: {
            return __assign(__assign({}, state), action.data);
        }
        default: {
            return state;
        }
    }
}
exports.default = default_1;
//# sourceMappingURL=EnvironmentInfo.js.map